import classnames from 'classnames';
import { PropTypes } from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import colors from '@general/colors';

const ButtonStyled = styled.button`
    font-size: 14px;

    &:hover {
        background-color: ${colors.admiral};
    }
`;

// TODO: Is there a point of this component when we can just just use ButtonPrimary styled component?
const Button = ({ children, onClick, buttonClasses = '', ...props }) => {
    const handleOnClick = e => {
        if (onClick) {
            e.preventDefault();
            onClick();
        }
    };

    const classes = classnames('btn', 'btn-primary', buttonClasses);

    return (
        <ButtonStyled type="button" onClick={handleOnClick} className={classes} {...props}>
            {children}
        </ButtonStyled>
    );
};

Button.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    onClick: PropTypes.func,
    buttonClasses: PropTypes.string,
};

export default Button;
